/* eslint-disable @typescript-eslint/no-type-alias */ /* eslint-disable @typescript-eslint/no-magic-numbers */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormDuration", {
    enumerable: true,
    get: function() {
        return FormDuration;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _useInputBorderCss = require("../useInputBorderCss");
const _useInputPadding = require("../useInputPadding");
const _durationString = /*#__PURE__*/ _interop_require_default(require("../../../util/durationString"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const handleBounds = (e, bounds)=>{
    const input = _durationString.default.toMinutes(e.currentTarget.value);
    if (input == null) {
        return;
    }
    let bounded = input;
    if (bounds.min != null) {
        bounded = Math.max(bounded, bounds.min);
    }
    if (bounds.max != null) {
        bounded = Math.min(bounded, bounds.max);
    }
    if (bounded !== input) {
        var _durationString_fromMinutes;
        e.currentTarget.value = (_durationString_fromMinutes = _durationString.default.fromMinutes(bounded)) !== null && _durationString_fromMinutes !== void 0 ? _durationString_fromMinutes : "";
    }
};
const onlyAllowValidCharacters = (e)=>{
    e.currentTarget.value = e.currentTarget.value.replace(/[^0-9:]/gu, "");
    const tokens = e.currentTarget.value.split(":");
    if (tokens.length > 1) {
        e.currentTarget.value = "".concat(tokens[0], ":").concat(tokens[1].slice(0, 2));
    }
};
const FormDuration = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { className, id: propsId, value: propsValue, placeholder, variant, rounded, min, max, onKeyDown, onInput, onChange, onBlur, ...inputProps } = param;
    const { colors, animationDuration } = (0, _Theme.useTheme)();
    const { id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        rounded
    });
    const padding = (0, _useInputPadding.useInputPadding)();
    const [localValue, setLocalValue] = (0, _react.useState)(propsValue);
    var _ref;
    const value = (_ref = propsValue !== null && propsValue !== void 0 ? propsValue : localValue) !== null && _ref !== void 0 ? _ref : "";
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("input", {
        ...inputProps,
        ref: ref,
        id: propsId !== null && propsId !== void 0 ? propsId : id,
        "aria-describedby": hintId,
        pattern: "/^\\d\\d+:\\d\\d$/u",
        value: value,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "hh:mm",
        onKeyDown: (e)=>{
            onlyAllowValidCharacters(e);
            if (onKeyDown != null) {
                onKeyDown(e);
            }
        },
        onInput: (e)=>{
            onlyAllowValidCharacters(e);
            if (onInput != null) {
                onInput(e);
            }
        },
        onChange: (e)=>{
            onlyAllowValidCharacters(e);
            handleBounds(e, {
                min,
                max
            });
            setLocalValue(e.target.value);
            if (onChange != null) {
                onChange(e);
            }
        },
        onBlur: (e)=>{
            const formatted = _durationString.default.format(e.currentTarget.value);
            if (formatted !== e.currentTarget.value) {
                e.currentTarget.value = formatted !== null && formatted !== void 0 ? formatted : "";
                setLocalValue(formatted);
                if (onChange != null) {
                    onChange(e);
                }
            }
            if (onBlur != null) {
                onBlur(e);
            }
        },
        className: _style.default.dynamic([
            [
                "dae74edec4a4777b",
                [
                    padding.shorthand,
                    variant === "lg" ? "24px" : "22px",
                    animationDuration,
                    variant === "lg" ? "16px" : "14px",
                    value === "" ? colors.muted1 : "inherit",
                    colors.muted1
                ]
            ]
        ]) + " " + "duration-input ".concat(borderCss.className, " ").concat(className !== null && className !== void 0 ? className : "")
    }), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "dae74edec4a4777b",
        dynamic: [
            padding.shorthand,
            variant === "lg" ? "24px" : "22px",
            animationDuration,
            variant === "lg" ? "16px" : "14px",
            value === "" ? colors.muted1 : "inherit",
            colors.muted1
        ]
    }, "input.__jsx-style-dynamic-selector{padding:".concat(padding.shorthand, ";line-height:").concat(variant === "lg" ? "24px" : "22px", "!important;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;cursor:pointer;float:none;outline:none;-webkit-transition:").concat(animationDuration, " box-shadow,border;-moz-transition:").concat(animationDuration, " box-shadow,border;-o-transition:").concat(animationDuration, " box-shadow,border;transition:").concat(animationDuration, " box-shadow,border;width:100%;font-size:").concat(variant === "lg" ? "16px" : "14px", "!important;color:").concat(value === "" ? colors.muted1 : "inherit", ";position:relative;background:white}.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:").concat(colors.muted1, "}.__jsx-style-dynamic-selector:-moz-placeholder{color:").concat(colors.muted1, "}.__jsx-style-dynamic-selector::-moz-placeholder{color:").concat(colors.muted1, "}.__jsx-style-dynamic-selector:-ms-input-placeholder{color:").concat(colors.muted1, "}.__jsx-style-dynamic-selector::-ms-input-placeholder{color:").concat(colors.muted1, "}.__jsx-style-dynamic-selector::placeholder{color:").concat(colors.muted1, "}")), borderCss.styles);
});
FormDuration.displayName = "FormDuration";

//# sourceMappingURL=FormDuration.js.map